import type { FragmentOf } from '@/utilities/gql';
import { gql } from '@/utilities/gql';

export const NARRATIVE_HEADER_COMPANY_FRAGMENT = gql(
  `
  fragment NarrativeHeaderCompanyFields on Company @_unmask {
    id
    tickerSymbol
    name
    info {
      url
    }
  }
`
);

export type NarrativeHeaderCompany = FragmentOf<
  typeof NARRATIVE_HEADER_COMPANY_FRAGMENT
>;
